module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921124151_T.c6fec335.jpg";